import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import App from "./App";
import { Container } from "react-bootstrap";
import { BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import ScrollTop from "./customJS/ScrollTop";
import { NavigationRoutes } from "./router/NavigationRoutes";
import ThemeProvider from "./config/ThemeProvider";
import { Provider } from "react-redux";
import store from "./RTK/store";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";
import { LoadScript } from "@react-google-maps/api";
import { REACT_APP_GOOGLE_MAPS_API_KEY } from "./config/app-config";

const root = ReactDOM.createRoot(document.getElementById("root"));

let persistor = persistStore(store);

const libraries = ["places"];

root.render(
  // <React.StrictMode>
  <LoadScript googleMapsApiKey={REACT_APP_GOOGLE_MAPS_API_KEY} libraries={libraries}>
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
          basename= "/United"
          // basename= {window.location.hostname === 'app.united-docs.com' ? "/" : "United"}
        >
          <ScrollTop>
            <Container fluid className="united p-0">
              <NavigationRoutes />
            </Container>
          </ScrollTop>
        </Router>
      </ThemeProvider>
      </PersistGate>
    </Provider>
    </LoadScript>
  // </React.StrictMode>
);
